import React, {useEffect, useState} from 'react';
import {Card, CardBody, Col} from 'reactstrap';
import FasteezyReportIndexDataTable from './FasteezyReportIndexDataTable';
import axios from "axios";
import {isEmpty} from '@/shared/helpers'
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import { getPrograms } from '@/shared/apiHelper.jsx';
import { getAllPrograms } from '@/shared/apiHelper.jsx';

const FasteezyReportCard = ({organization}) => {


  return (
    <Col md={12}>
      <Card>
        <CardBody>
          <FasteezyReportIndexDataTable />
        </CardBody>
      </Card>
    </Col>
  )
}
export default withRouter(connect((state) => ({
  organization: state.organization
}))(FasteezyReportCard));
